(() => {
  const STYLE_ID = "pi-recharge-subscription-shadow-style";

  /**
   * CSS lives inside the shadow tree only (global theme CSS cannot pierce shadow DOM).
   * Edit the rules below — use classes you see in DevTools under #shadow-root (open).
   */
  const css = `
    /* Example: scope to host */
    :host {
      display: block;
    }

    /* Examples — replace with your selectors (from Recharge widget DOM) */
    /* .rc-widget { } */
    /* .rc-selection__onetime .rc-price { font-weight: 600; } */
    .rc-purchase-option__badge {
        width: 100% !important;
        max-width: calc(100% - 33px) !important;
        right: unset !important;
        left: 10px !important;
        top: -18px !important;
        text-align: center !important;
    }
    .rc-plans-button__interval {
        hyphens: none !important;
    }
        .compact .rc-purchase-option__prices {
        display: flex;
        flex-direction: row !important;
        gap: 10px !important;
        align-items: flex-end !important;
        flex-wrap: wrap !important;
    }
  `;

  const polling = new WeakSet();

  function ensureStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  /** Host may be wrapped: find every <recharge-subscription-widget> including inside .recharge-subscription-widget */
  function collectHosts() {
    const hosts = new Set();
    document.querySelectorAll("recharge-subscription-widget").forEach((el) => hosts.add(el));
    document.querySelectorAll(".recharge-subscription-widget").forEach((el) => {
      if (el.tagName.toLowerCase() === "recharge-subscription-widget") {
        hosts.add(el);
      } else {
        el.querySelectorAll("recharge-subscription-widget").forEach((inner) => hosts.add(inner));
      }
    });
    return hosts;
  }

  function pollShadow(host, attempts) {
    if (host.shadowRoot) {
      ensureStyle(host.shadowRoot);
      return;
    }
    if (attempts >= 60) return;
    setTimeout(() => pollShadow(host, attempts + 1), 50);
  }

  function processHosts() {
    collectHosts().forEach((host) => {
      if (host.shadowRoot) {
        ensureStyle(host.shadowRoot);
      } else if (!polling.has(host)) {
        polling.add(host);
        pollShadow(host, 0);
      }
    });
  }

  processHosts();

  const mo = new MutationObserver(() => processHosts());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (window.customElements && typeof customElements.whenDefined === "function") {
    customElements.whenDefined("recharge-subscription-widget").then(() => processHosts());
  }
})();
